import { useEffect } from 'react';
import { Payment } from '@airwallex/components-sdk';
import { SurchargeFee } from '@/types/common';

// add EventCode corresponding payload type if needed
export type EventMap = {
  onSwitchMethod: {
    type: string;
    method: string;
    methodName: string;
    surchargeFee?: SurchargeFee;
  };
};

type EventPayload<T> = T extends keyof EventMap ? EventMap[T] : unknown;

const useMessageEvent = <T extends Payment.EventCode | 'message'>(
  code: T,
  handler: (event: T extends 'message' ? MessageEvent : CustomEvent<EventPayload<T>>) => void
): void => {
  useEffect(() => {
    window.addEventListener(code, handler as EventListener);

    return function cleanup() {
      window.removeEventListener(code, handler as EventListener);
    };
  }, [code, handler]);
};

export default useMessageEvent;
